module.exports = __webpack_public_path__ + "static/img/step02.f72957c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applyprocess/step02.png
// module id = Mpbd
// module chunks = 1